import { render, staticRenderFns } from "./pieChart1.vue?vue&type=template&id=0af4aa18&"
import script from "./pieChart1.vue?vue&type=script&lang=js&"
export * from "./pieChart1.vue?vue&type=script&lang=js&"
import style0 from "./pieChart1.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports